import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconName } from '../../icon-name';
import { IconStyle } from '../../icon-style';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-icon',
  templateUrl: './icon.component.html',
  standalone: false,
  host: { class: 'inline-block' },
})
export class IconComponent {
  @Input() size?: number | string;
  @Input() type?: IconStyle = 'line';
  @Input() name!: IconName;
}
